import { useEffect } from "react";
import "../../assets/css/custom.css";
import "../../assets/css/modal.css";
import { IoMdCheckmarkCircleOutline } from "react-icons/io";

export default function ApiListButton({ text, isActive, onClick }) {
  return (
    <div
      className={`apiListButton ${isActive ? "active" : ""}`}
      onClick={onClick}
    >
      <div className="apiCheckBox">
        <IoMdCheckmarkCircleOutline size={20} />
      </div>
      <div className="apiListButtonText">{text}</div>
      <div></div>
    </div>
  );
}
